export const lookupTableConfig = {
     list: {
          tableMapper: [
               {
                    id: "name",
                    name: "Name",
                    isShow: true,
                    align: "left",
                    type: "text",
                    isNormalTest: false,
               },
               // {
               //      id: "type",
               //      name: "Type",
               //      isShow: true,
               //      align: "center",
               //      type: "text",
               //      isNormalTest: true,
               // },
               {
                    id: "labels",
                    name: "Labels",
                    isShow: true,
                    align: "center",
                    type: "label",
               },
               {
                    id: "totalRecords",
                    name: "Total Records",
                    isShow: true,
                    align: "center",
                    type: "text",
                    width:200,
                    isNormalTest: false,
               },
               {
                    id: "inUse",
                    name: "In Use",
                    isShow: true,
                    align: "center",
                    type: "",
                    width:200,
               },
               {
                    id: "active",
                    name: "Active",
                    isShow: true,
                    align: "center",
                    type: "activeButton",
                    width:200,
               },
               {
                    id: "list1",
                    name: "",
                    isShow: true,
                    align: "left",
                    type: "",
               },
               {
                    id: "list2",
                    name: "",
                    isShow: true,
                    align: "left",
                    type: "",
               },
          ],
     },
};
